<template>
  <UContainer>
    <section class="py-12">
      <h2 class="text-3xl font-bold text-center mb-8">This week's highlights</h2>

      <!-- Tabs Navigation -->
      <UTabs 
        :items="tabs"
        class="w-full"
         color="neutral"
         variant="pill"
         :ui="{
            list: 'w-lg'
         }"
      >
        <!-- Best Sellers Tab Content -->
        <template #best-sellers>
          <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 pt-6">
            <ProductCard 
              v-for="product in bestSellers" 
              :key="product.id" 
              :product="product"
            />
          </div>
        </template>

        <!-- New Arrivals Tab Content -->
        <template #new-arrivals>
          <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 pt-6">
            <ProductCard 
              v-for="product in newArrivals" 
              :key="product.id" 
              :product="product"
            />
          </div>
        </template>

        <!-- Sale Items Tab Content -->
        <template #sale-items>
          <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 pt-6">
            <ProductCard 
              v-for="product in saleItems" 
              :key="product.id" 
              :product="product"
            />
          </div>
        </template>

        <!-- Top Rated Tab Content -->
        <template #top-rated>
          <div class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6 pt-6">
            <ProductCard 
              v-for="product in topRated" 
              :key="product.id" 
              :product="product"
            />
          </div>
        </template>
      </UTabs>
    </section>
  </UContainer>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue'
import ProductCard from '~/components/molecules/ProductCard.vue'
import type { ListProduct } from '~/types';

interface Props {
  products: ListProduct[]
}

const props = withDefaults(defineProps<Props>(), {
  products: () => []
})

const tabs = [
  {
    label: 'Best sellers',
    slot: 'best-sellers'
  },
  {
    label: 'New arrivals',
    slot: 'new-arrivals'
  },
  {
    label: 'Sale items',
    slot: 'sale-items'
  },
  {
    label: 'Top rated',
    slot: 'top-rated'
  }
]

// Filter products based on different criteria
const bestSellers = computed(() => {
  // Products marked as Popular or Featured
  return props.products
    // ?.filter(p => p.tags.find(t => t.name === 'Popular' || t.name === 'Featured'))
    // .slice(0, 8) || []
})

const newArrivals = computed(() => {
  // Products marked as New
  return props.products
    // ?.filter(p => p.badges?.includes('New'))
    // .slice(0, 8) || []
})

const saleItems = computed(() => {
  // Products marked as Sale
  return props.products
    // ?.filter(p => p.badges?.includes('Sale'))
    // .slice(0, 8) || []
})

const topRated = computed(() => {
  // Products with highest ratings
  return props.products
    // ?.filter(p => p.rating >= 4.5)
    // .sort((a, b) => (b.rating || 0) - (a.rating || 0))
    // .slice(0, 8) || []
})
</script>

<style scoped>
/* Additional custom styles if needed */
</style>
